export default __webpack_public_path__ + "static/O0158-3bd923d082d9d404ea0276b8f7c541b6.png";